import { GlobalElementsConfig, LineOfBusinessConfig, PageBrand } from '../types'

const geConfig: GlobalElementsConfig = {
  header: 'simple-header',
  footer: 'simple-footer',
}

const pageBrand: PageBrand = 'consumer'

export const simpleHeaderFooter = new LineOfBusinessConfig(geConfig, pageBrand)
